import { render, staticRenderFns } from "./MenuNavigation.vue?vue&type=template&id=18ea2cc9"
import script from "./MenuNavigation.vue?vue&type=script&lang=js"
export * from "./MenuNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports